import { Helmet } from 'react-helmet-async'
import LoginView from '../views/Login'
import { useLanguage } from '../i18n/LanguageContext'

const LoginPage = () => {
  const { t } = useLanguage()

  return (
    <>
      <Helmet>
        <title>{t('seo.loginTitle')}</title>
        <meta name="description" content={t('seo.loginDescription')} />
      </Helmet>
      <LoginView />
    </>
  )
}

export default LoginPage
